import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
} from '@mui/material';
import { SendMoneyListDto } from '../../../types/approval.types';
import { formatMoney, formatMoneyForTable, currencyToForm } from '../../../utils/approvalUtils';

interface SendMoneyTransactionDetailProps {
  data: SendMoneyListDto;
}

const SendMoneyTransactionDetail: React.FC<SendMoneyTransactionDetailProps> = ({ data }) => {
  // Data kontrolü - eğer Data yoksa veya array değilse boş döndür
  if (!data || !data.Data || !Array.isArray(data.Data) || data.Data.length === 0) {
    return null;
  }

  return (
    <Box sx={{ p: 2 }}>
      {data.Data.map((item, index) => (
        <Box key={index} sx={{ mb: index < data.Data.length - 1 ? 3 : 0 }}>
          {data.Data.length > 1 && (
            <Typography variant="h6" sx={{ mb: 2 }}>
              İşlem {index + 1}
            </Typography>
          )}
          
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Alıcı Hesap No"
                value={item.ReceiverWalletNo || ''}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tutar"
                value={formatMoneyForTable(item.Value, currencyToForm(item.CurrencyId))}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Komisyon"
                value={formatMoney(item.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Toplam"
                value={formatMoney(item.Value + item.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Para Birimi"
                value={currencyToForm(item.CurrencyId)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Açıklama"
                value={item.Description}
                disabled
                variant="outlined"
                size="small"
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default SendMoneyTransactionDetail;
